<template>
  <div class="rent-container">
    
      <div v-for="(r, index) in result" class="item-content" @click="openDetail(r)">

        <div class="item-img">
          <img :src="r.img"/>
        </div>

        <div class="item-des" style="color:rgba(88, 88, 88, 1);">
          <div style="font-size: 20px;color: black;">{{ r.title }}</div>
          <div>服务区域: {{ r.localtion }}</div>
          <div>发布人: {{ r.public }}</div>
          <div>联系方式: {{ r.mobile }}</div>

        </div>

        <div style="padding: 0 30px 0 10px;color:rgba(88, 88, 88, 1);">
          【{{r.time || 0}}】更新

        </div>

        <div style="padding: 0 30px 0 10px;color:rgba(88, 88, 88, 1);">
          {{r.num || 0}}次浏览

        </div>

      </div>
      <ItemDetail :centerDialogVisible="showDetail" :obj="obj" @close="showDetail = false"></ItemDetail>
  </div>
</template>
<script>
import {transfer} from '../../data/transfer'
import ItemDetail from '../../components/ItemDetail.vue'
  export default {
      name: 'Rent',
      components: {
        ItemDetail
      },
      data() {
        return {
          showDetail: false,
          obj: {},
          rents: transfer.data.map((item, index)=> {
            return {
              ...item,
              img: `/img/二手转让/${index + 1}.webp`
            }
          }) 
        }
      },
      computed: {
        result() {
          return [...this.rents, ...this.$store.getters.publishItems.filter(i => i.type == '1')]
        }
      },
      methods: {
        openDetail(item) {
          this.obj = item 
          this.showDetail = true
        }
      }
     
  }
</script>

<style scoped>
  
 .item-content {
  margin: 0 100px;
  padding: 5px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
 }

 .rent-container {
    padding: 20px 10vw;
    background: #ececec;
 }

 .item-img > img{
  width: 200px;
 }

 .item-des {
  flex: 1;
  padding: 0 20px;
  line-height: 2;
 }
  
</style>